import { render } from "./IndexNavbar.vue?vue&type=template&id=035dbc32"
import script from "./IndexNavbar.vue?vue&type=script&lang=js"
export * from "./IndexNavbar.vue?vue&type=script&lang=js"

import "./IndexNavbar.vue?vue&type=style&index=0&id=035dbc32&lang=css"

import exportComponent from "C:\\ami-website\\www-restore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__